<div class="container p-3">
	<div class="row">
		@for (stagingArea of stagingAreas; track stagingArea.id) {
			<div class="col-md-6 col-lg-4">
				<div class="card-wrapper card-space">
					<app-dossier
						class="w-100"
						[dossier]="stagingArea.dossier"
						[dossierType]=""
						[progressDelete]="
							progressRemoveStagingAreaId === stagingArea.id
						"
						[progressImport]="
							progressImportStagingAreaId === stagingArea.id
						"
						(deleteDossier)="
							currentStagingArea = stagingArea;
							deleteStagingAreaModal.toggle()
						"
						(importDossier)="
							currentStagingArea = stagingArea;
							importStagingAreaModal.toggle()
						"
					/>
				</div>
			</div>
		}
	</div>
</div>
<it-modal #importStagingAreaModal="itModal">
	<ng-container modalTitle>{{ "iterlex.import" | translate }}</ng-container>
	<form
		#importStagingAreaForm="ngForm"
		(ngSubmit)="onImportStagingAreaSubmit(importStagingAreaForm)"
	>
		@if (currentStagingArea) {
			<it-input
				type="number"
				name="newNumber"
				ngModel
				required
				[label]="'iterlex.number' | translate"
			></it-input>
			<it-input
				type="date"
				name="newDate"
				ngModel
				required
				[label]="'iterlex.date' | translate"
			></it-input>
			<button
				itButton="primary"
				type="submit"
				[disabled]="!importStagingAreaForm.valid"
				data-bs-dismiss="modal"
			>
				{{ "iterlex.create-dossier" | translate }}
			</button>
		}
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
<it-modal #importedStagingAreaModal alertModal="true">
	<ng-container modalTitle>{{
		"iterlex.imported-staging-area" | translate
	}}</ng-container>
	@if (currentStagingArea) {
		<p>
			{{
				"iterlex.imported-staging-area-description"
					| translate: { name: currentStagingArea.dossier.title }
			}}
		</p>
	}
</it-modal>
<it-modal
	#deleteStagingAreaModal="itModal"
	closeButton="false"
	popconfirm="true"
>
	<ng-container modalTitle>{{
		"iterlex.delete-staging-area-confirm" | translate
	}}</ng-container>
	@if (currentStagingArea) {
		<p>
			{{
				"iterlex.delete-staging-area-confirm-description"
					| translate: { name: currentStagingArea.dossier.title }
			}}
		</p>
	}
	<ng-container footer>
		@if (currentStagingArea) {
			<button
				itButton="danger"
				type="button"
				data-bs-dismiss="modal"
				(click)="removeStagingArea(currentStagingArea.id)"
			>
				{{ "it.core.remove" | translate }}
			</button>
		}
		<button
			itButton="outline-secondary"
			type="button"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.cancel" | translate }}
		</button>
	</ng-container>
</it-modal>
